module.exports = __webpack_public_path__ + "static/media/icon_facebook.f05fa14a.svg";